import { useParams } from "react-router-dom";
import {
  useCustomAlertStore,
  usePathStore,
  useSavePathStore,
} from "../../../../Store/store";
import {
  AutovehicleSpecsStore,
  usePathModeStore,
  PotreeGenerateAreaStore,
} from "../../../../Store/PotreeStore";
import { savePath } from "../../../../api/ProjectAPI";
import { sampleFullPath } from "../../utils/pathSampling";

/**
 * 수동 경로 저장(handleSavePath) + 자동 경로 저장(handleSaveAutoPath)
 * Pathgenerate 경로 저장 관련 로직만 분리
 */
export function usePathSave() {
  const { projectId } = useParams();
  const { showInfoAlert, showSuccessAlert } = useCustomAlertStore();
  const {
    equipmentPaths,
    setValidEquipmentPaths,
    allObstaclePoints,
  } = usePathStore();
  const { fullPathStore } = usePathModeStore();
  const {
    selectedAutovehicleSpecs,
    interval,
    size,
    WorkMode,
    seedPosition,
  } = AutovehicleSpecsStore();
  const { pathMode, minZ, direction } = PotreeGenerateAreaStore();
  const {
    setIsSavePathOpen,
    setOnConfirm,
    setIsSaveAutoPathOpen,
    setAutoPathData,
  } = useSavePathStore();

  const handleSavePath = async () => {
    let ValidPathCheck = false;
    let ValidPath = {};

    // 장비별 유효한 경로 체크
    for (const key in equipmentPaths) {
      if (equipmentPaths[key].markers.length >= 2) {
        ValidPathCheck = true;
        ValidPath = { ...ValidPath, [key]: equipmentPaths[key] };
      }
    }

    if (!ValidPathCheck) {
      showInfoAlert(
        "경로 저장 실패",
        "웨이 포인트가 2개 이하일 경우 저장할 수 없습니다.",
      );
      return;
    }

    // 경로 좌표 변환
    for (const key in ValidPath) {
      const waypointDetails = ValidPath[key].nodes.map((node, index) => ({
        x: node.x,
        y: node.y,
        z: node.z,
        sequence: index,
      }));
      ValidPath[key].nodes = waypointDetails;
    }

    // 장애물 좌표 변환
    const obstacles = allObstaclePoints.map(
      ({ name, description, points, areaTypeId }) => ({
        name,
        description,
        points: points.map(({ x, y, z }, index) => ({
          x,
          y,
          z,
          sequence: index,
        })),
        areaTypeId,
      }),
    );

    setValidEquipmentPaths(ValidPath);

    setOnConfirm(async ({ title, description, equipmentId }) => {
      const pathData = {
        name: title,
        description: description,
        // workType: "TRANSPORT",
        workType: `RIDGE_MANUAL`,
        agriculturalEquipmentId: equipmentId,
        waypointDetails: ValidPath[equipmentId].nodes,
        obstacles: obstacles,
        projectId: projectId,
      };

      try {
        const response = await savePath(pathData);
        if (response.id) {
          showSuccessAlert("경로 저장 성공", "경로를 저장했습니다.");
        }
      } catch (error) {
        console.error("경로 저장 실패:", error);
        showInfoAlert("경로 저장 실패", "경로를 저장할 수 없습니다.");
        throw error;
      }
    });

    setIsSavePathOpen(true);
  };

  // 자동 경로 생성의 저장버튼
  const handleSaveAutoPath = () => {
    // 일정 간격으로 베지어 곡선을 샘플링하여 좌표를 생성한다.
    if (!fullPathStore) {
      showInfoAlert("경로 저장 실패", "경로를 생성해주세요.");
      return;
    }

    const zBase = minZ() ? minZ() + 1 : 0;
    const waypoints = sampleFullPath(fullPathStore, 1.0, zBase);
    const workMode = WorkMode; // 작업 모드

    const data = {
      selectedAutovehicleSpecs,
      workMode,
      pathMode,
      interval,
      size,
      direction,
      waypoints,
      seedingSpacing: seedPosition,
      projectId,
    };

    setAutoPathData(data);
    setIsSaveAutoPathOpen(true);
  };

  return {
    handleSavePath,
    handleSaveAutoPath,
  };
}
